import {useEffect} from 'react';
import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import yapConnectionService from '../../../services/yap/yapConnectionService';
import {makeSelectIotDeviceFullData} from '../../../state/selectors/consumer';
import {makeSelectIsScpCheckInProgress, makeSelectIsStartAutoSync} from '../../../state/selectors/global';
import {makeSelectIsDeviceReady, selectIsFirmwareInProgress} from '../../../state/selectors/iotDevice';
import {
    makeSelectIsYapDeviceInfoReceived,
    makeSelectIsYapFirmwareInProgress,
    makeSelectIsYapUpdateSettingsInProgress,
} from '../../../state/selectors/yapEncrypted';

const mapStateToProps = createStructuredSelector({
    iotProduct: makeSelectIotDeviceFullData(),
    isDeviceReady: makeSelectIsDeviceReady(),
    isYapDeviceInfoReceived: makeSelectIsYapDeviceInfoReceived(),
    isStartAutoSync: makeSelectIsStartAutoSync(),
    isScpCheckInProgress: makeSelectIsScpCheckInProgress(),
    isFirmwareInProgress: selectIsFirmwareInProgress,
    isYapUpdateSettingsInProgress: makeSelectIsYapUpdateSettingsInProgress(),
    isYapFirmwareInProgress: makeSelectIsYapFirmwareInProgress(),
});

const DeviceConnectionChecker = ({
    iotProduct,
    isDeviceReady,
    isYapDeviceInfoReceived,
    isStartAutoSync,
    isScpCheckInProgress,
    isFirmwareInProgress,
    isYapUpdateSettingsInProgress,
    isYapFirmwareInProgress,
}) => {
    const {device} = iotProduct || {};
    const {deviceSerialNumber} = device || {};
    const isStartSync =
        deviceSerialNumber &&
        isDeviceReady &&
        !isYapDeviceInfoReceived &&
        isStartAutoSync &&
        !isScpCheckInProgress &&
        !isFirmwareInProgress &&
        !isYapUpdateSettingsInProgress &&
        !isYapFirmwareInProgress;

    useEffect(() => {
        if (isStartSync) {
            yapConnectionService.initSynchronizeFlow();
        }
    }, [isStartSync]);

    return null;
};

export default connect(mapStateToProps)(DeviceConnectionChecker);
